import { createAsyncTypes } from 'utils/ActionCreator'

export const SET_REPORT_DATA = 'ResolutionCenter/ReportComments/SET_REPORT_DATA'
export const TOGGLE_COMMUNITY_TAB = 'ResolutionCenter/ReportComments/TOGGLE_COMMUNITY_TAB'
export const COMMENTS_REQUEST_ASYNC = createAsyncTypes(
  'COMMENTS_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)
export const EDIT_COMMENT_REQUEST_ASYNC = createAsyncTypes(
  'EDIT_COMMENT_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)
export const DELETE_COMMENT_REQUEST_ASYNC = createAsyncTypes(
  'DELETE_COMMENT_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)
export const ADD_COMMENT_REQUEST_ASYNC = createAsyncTypes(
  'ADD_COMMENT_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)
export const ADD_REPLY_REQUEST_ASYNC = createAsyncTypes(
  'ADD_REPLY_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)
export const SAVE_NICKNAME_REQUEST_ASYNC = createAsyncTypes(
  'SAVE_NICKNAME_REQUEST_ASYNC',
  'ResolutionCenter/ReportComments'
)

export const NAME_FOR_HISTORY_STORE = 'reportComments'

export const mapStateNameByState = {
  7: 'spam',
  2: 'a safe',
  3: 'a phishing attack',
}

export const mapStateIconByState = {
  7: 'spam',
  2: 'false-positive',
  3: 'malicious',
}
